import React, { useEffect, useState } from 'react';
import { Smartphone, X } from 'lucide-react';
import RyanPwaInstallGuide, { detectDeviceOS, isRunningStandalone } from './RyanPwaInstallGuide';
import './RyanPwaInstallBanner.css';

const DISMISSED_KEY = 'ryan_pwa_banner_dismissed';

const RyanPwaInstallBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [showGuide, setShowGuide] = useState(false);

  useEffect(() => {
    if (isRunningStandalone()) return;
    if (detectDeviceOS() === 'other') return;
    if (localStorage.getItem(DISMISSED_KEY) === 'true') return;
    setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div className="rpib-banner">
        <span className="rpib-text">
          <Smartphone size={16} className="rpib-text-icon" />
          Sabia que dá pra ter o GRAIA Medicina como app no seu celular?
        </span>
        <div className="rpib-actions">
          <button className="rpib-cta" onClick={() => setShowGuide(true)}>Como instalar</button>
          <button className="rpib-close" onClick={dismiss} title="Dispensar" aria-label="Dispensar">
            <X size={15} />
          </button>
        </div>
      </div>

      {showGuide && (
        <div className="rpib-modal-overlay" onClick={() => setShowGuide(false)}>
          <div className="rpib-modal" onClick={e => e.stopPropagation()}>
            <div className="rpib-modal-header">
              <h3>Instalar o GRAIA Medicina</h3>
              <button className="rpib-close" onClick={() => setShowGuide(false)} aria-label="Fechar">
                <X size={16} />
              </button>
            </div>
            <RyanPwaInstallGuide />
          </div>
        </div>
      )}
    </>
  );
};

export default RyanPwaInstallBanner;
